import { render, staticRenderFns } from "./CloseTab.vue?vue&type=template&id=323c7998&scoped=true"
import script from "./CloseTab.vue?vue&type=script&lang=js"
export * from "./CloseTab.vue?vue&type=script&lang=js"
import style0 from "./CloseTab.vue?vue&type=style&index=0&id=323c7998&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323c7998",
  null
  
)

export default component.exports